import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';

/**
 * TEMPORARY: redirects legacy routing-test URLs while preserving query params and anchor targets.
 */
export const routingTestLegacyRedirect: CanActivateFn = () => {
  const router = inject(Router);

  return new RedirectCommand(
    router.createUrlTree(['/routing-test'], {
      queryParams: { from: 'legacy', redirected: 'true' },
      fragment: 'redirect-target',
    }),
  );
};
